// extracted by mini-css-extract-plugin
export default {"root":"ToggleLabel_root__P2BdU","tooltip":"ToggleLabel_tooltip__M-TZP","slider":"ToggleLabel_slider__FiBTB"};